import { Outlet, redirect } from 'react-router'
import { createClient } from '@/api-client'
import { Me } from '@/api-client/Me'
import { ScrollToTop } from '@/components/scroll-to-top'
import { NavigationBar } from '@/components/subscription/branch-navigation-bar'
import { Notification } from '@/components/subscription/notification'

export const loader = async () => {
  try {
    return await fetchMe()
  } catch {
    return redirect('/subscription/rose/login')
  }
}

async function fetchMe() {
  return createClient(Me).getMe()
}

export const SubscriptionRoseMypageLayout: React.FC = () => {
  return (
    <Layout>
      <ScrollToTop />
      <Outlet />
    </Layout>
  )
}

const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <>
      <NavigationBar basePath="/subscription/rose" />
      <article className="min-h-screen bg-bg font-sans">
        <main className="pt-20 pb-16 px-5 max-w-2xl mx-auto flex flex-col gap-8">
          {children}
        </main>
        <Notification />
      </article>
    </>
  )
}
